import { Check, X } from '@phosphor-icons/react'
import { Button } from 'ComponentLibrary'
import { BaseSyntheticEvent } from 'react'

type FormFooterButtonsProps = {
    onSubmit?: (event: BaseSyntheticEvent) => void
    onCancel?: () => void
    shouldDisableSubmit?: boolean
    dense?: boolean
    isPersisting?: boolean
    copy?: Partial<FormFooterButtonsCopy>
}

export type FormFooterButtonsCopy = {
    cancelAriaLabel: string
    submitAriaLabel: string
}

const DEFAULT_FORM_FOOTER_BUTTONS_COPY: FormFooterButtonsCopy = {
    cancelAriaLabel: 'Cancel',
    submitAriaLabel: 'Submit',
}

export default function FormFooterButtons({
    onSubmit,
    onCancel,
    shouldDisableSubmit,
    dense = false,
    isPersisting,
    copy,
}: FormFooterButtonsProps) {
    const resolvedCopy = { ...DEFAULT_FORM_FOOTER_BUTTONS_COPY, ...copy }
    return (
        <>
            {onCancel && (
                <Button
                    size={dense ? 'small' : 'medium'}
                    variant={'secondary'}
                    startIcon={<X />}
                    onClick={onCancel}
                    disabled={isPersisting}
                    aria-label={resolvedCopy.cancelAriaLabel}
                />
            )}
            {onSubmit && (
                <Button
                    size={dense ? 'small' : 'medium'}
                    variant={'primary'}
                    startIcon={<Check />}
                    onClick={onSubmit}
                    disabled={shouldDisableSubmit || isPersisting}
                    aria-label={resolvedCopy.submitAriaLabel}
                />
            )}
        </>
    )
}
